import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './fr.json';
import en from './en.json';
import nl from './nl.json';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LANGS = ['fr', 'en', 'nl'] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'fr',
        load: 'languageOnly',

        supportedLngs: [...SUPPORTED_LANGS],

        resources: {
            fr: { translation: fr },
            en: { translation: en },
            nl: { translation: nl },
        },
        detection: {
            order: ['navigator', 'htmlTag'],
            caches: [],
        },
    });

i18n.on('languageChanged', (lng) => {
    document.documentElement.lang = lng;
});
